export default "__VITE_ASSET__BzA8xf9A__"